import { Maksukortti } from '@lemon/core-firebase/model/maksukortti'
import { Maksutapa } from '@lemon/core-firebase/model/tosite'

export interface TallennetunTositteenKorttiehdokas {
  tunnistettuKortti: string | null
  maksutapa: number | null
}

export interface EsivalittavaMaksutapa {
  readonly value: number | null
  readonly disabled: boolean
  setValue(maksutapa: number | null): void
}

export interface EhdotettavaMaksukortti {
  viimeiset4: string
  maksutapa: Maksutapa
}

export function muotoileKortinNumero(viimeiset4: string): string {
  return `•••• ${viimeiset4}`
}

export function etsiMaksukortti(kortit: Maksukortti[], viimeiset4: string | null | undefined): Maksukortti | null {
  if (!viimeiset4) {
    return null
  }
  return kortit.find(kortti => kortti.viimeiset4 === viimeiset4) ?? null
}

export function onkoKorttiJoTallennettu(kortit: Maksukortti[], viimeiset4: string): boolean {
  return etsiMaksukortti(kortit, viimeiset4) !== null
}

export function etsiAktiivinenMaksutapa(maksutavat: Maksutapa[], tunniste: number | null | undefined): Maksutapa | null {
  if (tunniste === null || tunniste === undefined) {
    return null
  }
  return maksutavat.find(maksutapa => maksutapa.i === tunniste && maksutapa.a) ?? null
}

export function esivalitseMaksutapaKortilla(kontrolli: EsivalittavaMaksutapa, viimeiset4: string | null | undefined, kortit: Maksukortti[], maksutavat: Maksutapa[]): boolean {
  if (kontrolli.value !== null && kontrolli.value !== undefined) {
    return false
  }
  if (kontrolli.disabled) {
    return false
  }
  const kortti = etsiMaksukortti(kortit, viimeiset4)
  if (!kortti) {
    return false
  }
  const maksutapa = etsiAktiivinenMaksutapa(maksutavat, kortti.maksutapaTunniste)
  if (!maksutapa) {
    return false
  }
  kontrolli.setValue(maksutapa.i)
  return true
}

export function etsiEhdotettavaKortti(ehdokkaat: TallennetunTositteenKorttiehdokas[], kortit: Maksukortti[], maksutavat: Maksutapa[], vaimennetutKortit: string[]): EhdotettavaMaksukortti | null {
  for (const ehdokas of ehdokkaat) {
    if (!ehdokas.tunnistettuKortti || onkoKorttiJoTallennettu(kortit, ehdokas.tunnistettuKortti) || vaimennetutKortit.includes(ehdokas.tunnistettuKortti)) {
      continue
    }
    const maksutapa = etsiAktiivinenMaksutapa(maksutavat, ehdokas.maksutapa)
    if (!maksutapa) {
      continue
    }
    return { viimeiset4: ehdokas.tunnistettuKortti, maksutapa }
  }
  return null
}
